export enum RecommendedJobsSourceTypes {
    AI_MATCH = "aiMatch",
    AI_MATCH_FALLBACK = "aiMatchFallback",
    AI_MATCH_LEGACY = "aiMatchLegacy",
    MATCH = "match",
    MATCH_LEGACY = "matchLegacy",
    NONE = "none"
}